import * as React from 'react'

function SvgAe(props) {
	return (
		<svg viewBox="0 0 12 6" width="1em" height="1em" {...props}>
			<path fill="#00732f" d="M0 0h12v2H0z" />
			<path fill="#fff" d="M0 2h12v2H0z" />
			<path d="M0 4h12v2H0z" />
			<path fill="red" d="M0 0h3v6H0z" />
		</svg>
	)
}

export default SvgAe
